import { appUrl } from '@astro/config'
import DiyaVisual from '../components/pooja/DiyaVisual'
import PoojaListingSection from '../components/pooja/PoojaListingSection'
import HowItWorksSection from '../components/pooja/HowItWorksSection'
import WhyEnergizeSection from '../components/pooja/WhyEnergizeSection'
import EnergizationLevelsSection from '../components/pooja/EnergizationLevelsSection'
import RitualProcessSection from '../components/pooja/RitualProcessSection'
import SamagriSection from '../components/pooja/SamagriSection'
import DosDontsSection from '../components/pooja/DosDontsSection'
import PoojaFaqSection from '../components/pooja/PoojaFaqSection'
import PoojaCtaSection from '../components/pooja/PoojaCtaSection'
import AcademyCtaSection from '../components/pooja/AcademyCtaSection'

const HERO_CHIPS = [
  { icon: 'fa-gopuram', label: 'Verified Temples' },
  { icon: 'fa-om', label: 'Sankalp With Gotra' },
  { icon: 'fa-video', label: 'Pooja Video on WhatsApp' },
]

const HERO_STATS = [
  { value: '650+', label: 'Vedic Rituals' },
  { value: '10L+', label: 'Devotees Served' },
  { value: '4.8★', label: 'Seva Rating' },
]

export default function PoojaEnergization() {
  return (
    <>
      {/* Dark hero — the fixed header overlays it transparently (see Header's
          overlayRoute), so the hero carries its own top clearance. */}
      <section className="relative overflow-hidden hero-bg text-white md:px-12">
        <div className="absolute inset-0 bg-[radial-gradient(60%_55%_at_75%_42%,rgba(232,119,15,0.16),transparent_70%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(48%_50%_at_12%_88%,rgba(122,31,43,0.28),transparent_70%)]" />

        <div className="relative z-10 container mx-auto max-w-350 px-6 md:px-10 lg:px-16 pt-36 md:pt-44 pb-10 md:pb-16">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div className="space-y-6 text-center lg:text-left flex flex-col items-center lg:items-start">
              <div className="flex items-center gap-3">
                <span className="text-xl text-secondary">ॐ</span>
                <span className="font-semibold text-[#E6C878] tracking-[0.28em] text-xs uppercase">॥ Ritual Protocol ॥</span>
              </div>
              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-heading leading-[1.1] tracking-tight uppercase font-normal text-[#FBF3E4]">
                Pooja <br /><span className="text-gradient-gold font-bold">Energization</span>
              </h1>
              <p className="text-sm md:text-base text-white/65 max-w-xl font-normal leading-relaxed">
                Book sacred poojas at India's holiest temples — performed by verified priests in your
                name and gotra, with <span className="text-secondary font-semibold">sankalp video proof</span> on
                WhatsApp and prasad at your doorstep. The same Vedic vidhi that energizes every product we ship.
              </p>

              <div className="flex flex-wrap justify-center lg:justify-start gap-3 pt-1">
                {HERO_CHIPS.map((chip) => (
                  <div key={chip.label} className="flex items-center gap-2.5 px-5 py-2 rounded-full border border-white/10 bg-white/5 text-[10px] font-medium uppercase tracking-widest text-white/60">
                    <i className={`fa-solid ${chip.icon} text-secondary`}></i> {chip.label}
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4 w-full sm:w-auto">
                <a
                  href="#book-pooja"
                  className="bg-secondary hover:bg-amber-600 text-white font-bold px-8 py-4 rounded-full text-xs uppercase tracking-widest text-center shadow-lg transition duration-300"
                >
                  Book A Pooja <i className="fa-solid fa-arrow-right ml-1"></i>
                </a>
                <a
                  href={appUrl('jyotish')}
                  className="border border-[#E6C878]/40 hover:border-[#E6C878] text-[#FBF3E4] font-bold px-8 py-4 rounded-full text-xs uppercase tracking-widest text-center transition duration-300"
                >
                  Consult an Expert
                </a>
              </div>

              {/* Trust stats */}
              <div className="flex items-center justify-center lg:justify-start gap-8 pt-4 border-t border-white/10 w-full">
                {HERO_STATS.map((s) => (
                  <div key={s.label} className="text-center lg:text-left">
                    <p className="font-heading text-xl md:text-2xl text-gradient-gold font-bold">{s.value}</p>
                    <p className="text-[9px] uppercase tracking-widest text-white/40 mt-0.5">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <DiyaVisual />
          </div>
        </div>
      </section>

      {/* The bookable-pooja storefront */}
      <PoojaListingSection />
      <HowItWorksSection />

      {/* Product-energization knowledge sections (pre-existing) */}
      <WhyEnergizeSection />
      <EnergizationLevelsSection />
      <RitualProcessSection />
      <SamagriSection />
      <DosDontsSection />

      <PoojaFaqSection />
      <PoojaCtaSection />
      <AcademyCtaSection />
    </>
  )
}
